<template>
  <div>
    <overview-layout ref="overview" :tableCfg="tableCfg">
      <template slot="AdvancedFilter">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
          <div class="row">
            <detail-field class="col-md-4" label="Contract/Student" field="contract_id" :optionListApiUrl="'/contracts/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="isPlanned" label="Planned before" type="date" field="planned_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="!isPlanned" label="Expired after" type="date" field="expired_after" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="isNumbered" label="Open" field="open" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" label="Email Sent" field="email_sent" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="!isCreditNote" label="Document Type" field="document_type_id" :optionListApiUrl="'/document_types_invoices/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="isCreditNote" label="Document Type" field="document_type_id" :optionListApiUrl="'/document_types_creditnotes/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="isNumbered" label="Pro Forma" field="pro_forma" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" label="Program" field="program_id" :optionListApiUrl="'/programs/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" label="Round" field="application_round" :optionListApiUrl="'/contracts_round/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" v-if="isNumbered" label="Status" field="contract_status_id" :optionListApiUrl="'/contract_status/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-4" label="Instalments" field="instalments" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          </div>

        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item @click="exportSelection('/invoices/download_report', 'Invoices.xlsx')">Export Selection</b-dropdown-item>
            <b-dropdown-item @click="exportSelection('/invoices/download_report_open', 'Invoices Open.xlsx')">Export Open Invoices</b-dropdown-item>
          </b-dropdown>
          <b-dropdown v-if="hasSelections() && privUser" variant="default" size="sm">
            <template slot="button-content">
                <i class="fa fa-rocket"></i> Batch
            </template>
            <b-dropdown-item v-if="privAdministrator && (isPlanned || isNumbered)" @click="$refs.modalBulkEdit.show()">Bulk Edit</b-dropdown-item>
            <b-dropdown-item v-if="isPlanned" @click="$refs.modalCreateInvoiceOk.show()">Create Invoice</b-dropdown-item>
            <b-dropdown-item v-if="!isPlanned" @click="$refs.overview.runBatch(sendEmail, 'document_reference')">Send Email</b-dropdown-item>
            <b-dropdown-item v-if="!isPlanned" @click="$refs.overview.runBatch(sendEmailReminder, 'document_reference')">Send Email Reminder</b-dropdown-item>
          </b-dropdown>
      </template>
      <template slot="ExtraRowActions" scope="props">
        <button
          v-if="isNumbered"
          class="btn btn-default btn-sm"
          :disabled="!privUser"
          @click="$router.push({ name: 'invoicepayment', params: {id: 'new'}, query: {invoice_id: props.rowData.id} })">
          <i class="fa fa-money"></i>
        </button>
      </template>
    </overview-layout>
    <b-modal ref="modalCreateInvoiceOk" title="Create Invoices" ok-title="Yes" close-title="No" @ok="$refs.overview.runBatch(createPDF, 'document_reference')" >
      Are you sure you want to create these invoices?
    </b-modal>
    <b-modal ref="modalBulkEdit" title="Bulk Edit" ok-title="Apply" close-title="Cancel" @ok="bulkOk('/invoices/bulk_edit')" >
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <detail-field class="col-md-10" label="Amount" field="amount" :rec="bulkRec" type="money" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field v-if="isPlanned" class="col-md-10" label="Planned Date" field="planned_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="!isPlanned" class="col-md-10" label="Expiration Date" field="expiration_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field v-if="!isPlanned" class="col-md-10" label="Extended Deadline" field="extended_deadline_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'
function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
export default {
  name: 'invoice_overview',
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  computed: {
    isNumbered () { return this.tableCfg.subType(this) === 'numbered' },
    isPlanned () { return this.tableCfg.subType(this) === 'planned' },
    isCreditNote () { return this.tableCfg.subType(this) === 'creditnote' }
  },
  methods: {
    payMoney (props) {
      console.log(props.rowData.id)
    },
    simpleSleep (id, okFnc, errorFnc) {
      sleep(100).then(() => {
        okFnc('ok')
      })
    },
    createPDF (id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/create_pdf', {}, okFnc, errorFnc, this.$refs.overview.alert)
      // this.api.get('/invoices/' + id, {}, okFnc, errorFnc, this)
    },
    sendEmail (id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/send_email', {reminder: false}, okFnc, errorFnc, this.$refs.overview.alert)
      // this.api.get('/invoices/' + id, {}, okFnc, errorFnc, this)
    },
    sendEmailReminder (id, okFnc, errorFnc) {
      this.api.post('/invoices/' + id + '/send_email', {reminder: true}, okFnc, errorFnc, this.$refs.overview.alert)
      // this.api.get('/invoices/' + id, {}, okFnc, errorFnc, this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?6e84327d